import { Injectable } from '@angular/core';
import { OpenIdConfiguration, StsConfigStaticLoader } from 'angular-auth-oidc-client';
import { PlatformHostIntegration } from 'src/app/integrations/models/platform-host-integration.enum';
import { PlatformIntegration } from 'src/app/integrations/models/platform-integration.enum';
import { environment } from 'src/environments/environment';
import { IAuth0Configuration } from '../models/auth0Config.model';

@Injectable({ providedIn: 'root' })
export class ConfigService {
  platform: PlatformIntegration;
  authConfigSelector: number;

  constructor() {
    this.verifyPlatform();
    this.setAuthConfigForClient();
  }

  getConfig(): OpenIdConfiguration | IAuth0Configuration {
    switch (this.authConfigSelector) {
      case 1:
        return {
          authority: environment.urlAuthority,
          redirectUrl: environment.urlEnvRedirect,
          postLogoutRedirectUri: environment.urlEnvPostRedirect,
          clientId: environment.clientId,
          scope: environment.IDPScope,
          responseType: environment.IDPResponseType,
          silentRenew: true,
          useRefreshToken: true,
          autoUserInfo: false,
          historyCleanupOff: false,
          maxIdTokenIatOffsetAllowedInSeconds: 300
        };

      case 2:
        return {
          skipRedirectCallbackURL: environment.auth0SkipRedirectCallbackURL,
          domain: environment.urlAuthorityAM,
          clientId: environment.clientIdAM,
          audience: environment.AudienceAM,
          scope: environment.IDPScopeAM,
          urlRedirect: environment.urlEnvRedirectAM
        };
    }
  }

  useDefaultConfig() {
    this.authConfigSelector = 1;
  }

  verifyPlatform() {
    const url = window.location.href;
    if (url.includes(PlatformHostIntegration.aeroMHost)) {
      this.platform = PlatformIntegration.salesforce;
    } else {
      this.platform = PlatformIntegration.default;
    }
  }

  setAuthConfigForClient() {
    switch (this.platform) {
      case PlatformIntegration.default:
        this.useDefaultConfig();
        break;

      case PlatformIntegration.salesforce:
        this.authConfigSelector = 2;
        break;
    }
  }
}

export const OIDCAuthFactory = (configService?: ConfigService): StsConfigStaticLoader =>
  new StsConfigStaticLoader(configService.getConfig());

export const Auth0AuthFactory = (): IAuth0Configuration => {
  const configService = new ConfigService();
  return configService.getConfig();
};
